import { V3Models } from "@istari/istari-client";

import {
  ElseTagRule,
  TagRule,
  TagRuleIfClause,
  TagRuleIfClauseKind,
  TagRuleSet,
  TagRuleThenClause,
  TagRuleThenClauseKind,
  TagRuleTransformation,
  TagRuleVerdict,
} from "~/secure-connections/model/tag-rule";

import { toTransformationKind } from "./to-transformation";

export function toTagRuleSet(dto: V3Models.TagRuleSetDto): TagRuleSet {
  return {
    rules: dto.rules.map(toTagRule),
    elseRule: toElseTagRule(dto.elseRule),
  };
}

export function toTagRule(dto: V3Models.TagRuleDto): TagRule {
  return {
    id: dto.id,
    ifClause: toTagRuleIfClause(dto.ifClause),
    thenClause: toTagRuleThenClause(dto.thenClause),
    verdict: toTagRuleVerdict(dto.verdict),
    transformations: dto.transformations.map(toTagRuleTransformation),
    ordinal: dto.ordinal,
    description: dto.description,
  };
}

export function toElseTagRule(dto: V3Models.ElseTagRuleDto): ElseTagRule {
  return {
    id: dto.id,
    verdict: toTagRuleVerdict(dto.verdict),
    transformations: dto.transformations.map(toTagRuleTransformation),
    description: dto.description,
  };
}

function toTagRuleIfClause(dto: V3Models.TagRuleIfClauseDto): TagRuleIfClause {
  return { kind: toIfClauseKind(dto.kind), controlTagIds: dto.controlTagIds ?? [] };
}

function toTagRuleThenClause(dto: V3Models.TagRuleThenClauseDto): TagRuleThenClause {
  return { kind: toThenClauseKind(dto.kind), controlTagIds: dto.controlTagIds ?? [] };
}

function toTagRuleTransformation(dto: V3Models.TagRuleTransformationDto): TagRuleTransformation {
  return {
    id: dto.id,
    fieldType: toTransformationKind(dto.fieldType),
    predicate: dto.predicate ?? null,
    value: dto.value ?? null,
  };
}

// Exhaustive switches so a new SDK literal is a compile error, not an
// "unknown" fallthrough.
function toIfClauseKind(dto: V3Models.TagRuleIfClauseKind): TagRuleIfClauseKind {
  switch (dto) {
    case "no_tags":
    case "any":
    case "all":
    case "any_not_in":
      return dto;
  }
}

function toThenClauseKind(dto: V3Models.TagRuleThenClauseKind): TagRuleThenClauseKind {
  switch (dto) {
    case "no_further_checks":
    case "any":
    case "all":
      return dto;
  }
}

export function toTagRuleVerdict(dto: V3Models.TagRuleVerdict): TagRuleVerdict {
  switch (dto) {
    case "allow":
    case "block":
      return dto;
  }
}
